import React, { useEffect, useState } from "react";
import BannerHome from "../page/home/BannerHome";
import BrandHome from "../page/home/Brand";
import SellingHot from "../page/home/SellingHot";
import ProductCategory from "../page/home/ProductCategory";
import { getCategoryTree } from "../server/category/getTree";
import { Skeleton } from "../components/Skeleton";

interface CategoryItem {
  id: string;
  name: string;
  children?: { id: string; name: string }[];
}

export default function Home() {
  const [data, setData] = useState<CategoryItem[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchTree() {
      try {
        const res = await getCategoryTree();
        setData(res || []);
      } catch (error) {
        console.error("Fetch category tree failed:", error);
      } finally {
        setLoading(false);
      }
    }

    fetchTree();
  }, []);
  return (
    <>
      <BannerHome />
      <BrandHome />
      <SellingHot />
      {loading &&
        Array.from({ length: 2 }).map((_, idx) => (
          <CategorySkeleton key={idx} />
        ))}
      {data?.slice(0, 3).map((item: CategoryItem) => (
        <React.Fragment key={item.id}>
          <ProductCategory
            id={item.id}
            name={item.name}
            children={item.children ?? []}
          />
        </React.Fragment>
      ))}
    </>
  );
}

function CategorySkeleton() {
  return (
    <section className="relative px-4 py-10">
      <div className="mx-auto max-w-7xl space-y-4 rounded-3xl bg-white/70 p-6 shadow-lift ring-1 ring-slate-100">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <div>
            <Skeleton className="h-4 w-24" />
            <Skeleton className="mt-2 h-6 w-48" />
          </div>
          <div className="flex flex-wrap gap-2">
            {Array.from({ length: 4 }).map((_, idx) => (
              <Skeleton key={idx} className="h-8 w-24 rounded-full" />
            ))}
          </div>
        </div>

        <div className="grid gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
          {Array.from({ length: 5 }).map((_, idx) => (
            <div key={idx} className="space-y-3 rounded-2xl border border-slate-100 bg-white p-3">
              <Skeleton className="h-36 w-full rounded-xl" />
              <Skeleton className="h-4 w-3/4" />
              <Skeleton className="h-4 w-1/2" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
